import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withMemo as _withMemo, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7c7faa96"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "text-container" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "branding title" }, "Make room for", -1));
const _hoisted_3 = { class: "word-slider" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return _withMemo([_ctx.currentBuzzword], () => (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['image-carosel', _ctx.image])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    ref: "buzzwordContainer",
                    class: "branding buzzword"
                }, _toDisplayString(_ctx.currentBuzzword), 513)
            ])
        ])
    ], 2)), _cache, 0);
}
